import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FlywheelSection } from "@/components/sections/FlywheelSection";
import { CTASection } from "@/components/sections/CTASection";

const GrowthSystem = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <FlywheelSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default GrowthSystem;
